import PatientInfo from "./components/PatientInfo";

export default PatientInfo